<template>
  <button
    :class="[
      'chip-tag',
      {
        'chip-tag--active': isActive,
        'chip-tag--icon': hasIcon,
        'chip-tag--filled': hasFill,
        'chip-tag--no-border': hasNoBorder
      }
    ]"
    :text="text"
  >
    <slot />
    <span class="chip-tag__text">
      {{ text }}
    </span>
  </button>
</template>

<script setup lang="ts">

import { computed, useSlots } from 'vue'

export interface Props {
  text: string;
  isActive?: boolean;
  hasFill?: boolean;
  hasNoBorder?: boolean;
}

const props = withDefaults(defineProps<Props>(), { 
  isActive: false,
  hasFill: false,
  hasNoBorder: false 
})

const slots = useSlots()

const hasIcon = computed(() => slots.default !== undefined)

</script>

<style lang="scss">

.chip-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid $grey-60;
  box-sizing: border-box;
  border-radius: 50px;
  padding: 0px 15px;
  background-color: transparent;
  gap: 4px;
  height: 34px;
  cursor: pointer;
  transition: border-color 150ms $animationCurve;

  &__text {
    font-family: $font-bold;
    font-size: 14px;
    color: $white;
    line-height: 18px;
  }

  &:hover {
    border: 1px solid $white;
  }

  &--active {
    background-color: rgba($purple-dark, 0.5);
    border: 1px solid $purple-dark;

    &:hover {
      border: 1px solid $purple-dark;
    }
  }

  &--icon {
    padding: 7px 15px 7px 9px;
  }

  &--no-border {
    border: 1px solid transparent;
  }

  &--filled {
    background: rgba($purple-light, 0.2);
  }
}

</style>
